import Cookies from "js-cookie";
const LOCALE_KEY = "locale";
const DEFAULT_LOCALE = "PH";

export function setLocale(locale) {
  Cookies.set(LOCALE_KEY, locale, {
    expires: 365,
  });
}

export function getLocale() {
  return Cookies.get(LOCALE_KEY) || DEFAULT_LOCALE;
}
